import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionStorageService } from '../services/authentication/session-storage.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const session = inject(SessionStorageService).loadSession();
  if (!session) return next(req);
  const jwt = JSON.parse(session)['jwt'];

  const newReq = req.clone({
    headers: req.headers.append('Authorization', `Bearer ${jwt}`),
  });
  return next(newReq);
}
